<div class="flex flex-col md:flex-row min-h-screen w-full overflow-x-hidden overflow-y-auto">
  <!-- Left Section (Signup Form) -->
  <div
    class="w-full md:w-1/2 flex items-center justify-center signup-left px-6 sm:px-8 py-8 sm:py-12 md:py-12"
  >
    <div class="w-full max-w-md sm:max-w-lg md:max-w-md signup-form-container">
      <!-- Logo -->
      <app-botmaa
        logoWidth="w-8"
        logoHeight="h-12"
        logoMarginRight="mr-2"
        titleSize="text-3xl"
        boxPadding="p-2"
        footerTextSize="text-[10px]"
        footerMarginTop="mt-1"
        containerMarginBottom="mb-6"
        responsiveLogoWidth="sm:w-10"
        responsiveLogoHeight="sm:h-14"
        responsiveLogoMargin="sm:mr-3"
        responsiveTitleSize="sm:text-4xl"
        responsiveBoxPadding="sm:p-3"
        responsiveFooterSize="sm:text-xs"
        responsiveFooterMargin="sm:mt-2"
        responsiveContainerMargin="sm:mb-8"
      ></app-botmaa>

      <!-- Heading -->
      <h1 class="text-xl sm:text-2xl font-bold text-gray-800 mb-1 text-center mt-4 sm:mt-6">
        Create an account
      </h1>
      <p class="text-center text-xs sm:text-sm text-gray-500 mb-4 sm:mb-6">
        Just a few things to get started.
      </p>

      <!-- Signup Form -->
      <form
        [formGroup]="signupForm"
        (ngSubmit)="handleSubmit()"
        class="space-y-4 sm:space-y-4 signup-form"
      >
        <!-- Full Name -->
        <app-form-field
          label="Full Name"
          id="fullName"
          type="text"
          placeholder="Enter Full Name"
          [formControl]="$any(signupForm.get('fullName'))"
          labelClass="block text-gray-700 text-xs sm:text-sm font-medium"
          inputClass="w-full h-10 px-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-botmaaOrange text-sm"
        ></app-form-field>

        <!-- Email -->
        <app-form-field
          label="Email"
          id="email"
          type="email"
          placeholder="Enter Email Address"
          [formControl]="$any(signupForm.get('email'))"
          labelClass="block text-gray-700 text-xs sm:text-sm font-medium"
          inputClass="w-full h-10 px-3 mt-0 email-signup border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-botmaaOrange text-sm"
        ></app-form-field>

        <!-- Password -->
        <app-password-input
          label="Password"
          id="password"
          placeholder="Enter Password"
          [formControl]="$any(signupForm.get('password'))"
          labelClass="block text-gray-700 text-xs sm:text-sm font-medium"
          inputClass="w-full h-10 px-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-botmaaOrange pr-10 text-sm"
        ></app-password-input>

        <!-- Confirm Password -->
        <app-password-input
          label="Confirm Password"
          id="confirmPassword"
          placeholder="Enter Password"
          [formControl]="$any(signupForm.get('confirmPassword'))"
          labelClass="block text-gray-700 text-xs sm:text-sm font-medium"
          inputClass="w-full h-10 px-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-botmaaOrange pr-10 text-sm"
        ></app-password-input>

        <!-- Submit -->
        <app-form-submit-button
          type="submit"
          [loading]="loading"
          label="Sign Up"
          loadingLabel="Signing up..."
          buttonClass="w-full bg-orange-500 hover:bg-orange-600 text-white font-medium py-2 rounded-md shadow-md transition duration-200 text-sm sm:text-base"
        ></app-form-submit-button>

        <!-- Already have account -->
        <app-auth-link
          questionText="Already have an account?"
          linkText="Sign In"
          linkRoute="/login"
          containerClass="text-center text-xs sm:text-sm text-gray-600 mt-2 sm:mt-3"
        ></app-auth-link>
      </form>
    </div>
  </div>

  <!-- Right Section (Welcome Panel) -->
  <div
    class="hidden md:flex w-[50%] relative items-center justify-center overflow-hidden rightSection SignupBG p-4 md:p-5 px-6 md:px-8 lg:px-12"
  >
    <!-- Background Image -->
    <div class="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-90"></div>

    <!-- Gradient Overlay -->
    <div class="absolute inset-0 bg-gradient-to-br from-[#5035AB]/80 to-[#6454CD]/100"></div>

    <!-- Content Box -->
    <div
      class="relative w-full max-w-sm md:max-w-md lg:max-w-lg text-white p-6 md:p-8 lg:p-10 rounded-2xl md:rounded-3xl backdrop-blur-sm bg-white/10 animate-slideFade shadow-2xl overflow-visible"
    >
      <h2 class="text-xl md:text-2xl font-bold mb-3 md:mb-4 leading-tight">
        Welcome to Your Trading Edge!
      </h2>
      <p class="text-xs md:text-sm font-medium opacity-90 mb-4 md:mb-6">
        Unlock the Power of Intelligent Automation.
      </p>

      <p class="text-xs md:text-sm opacity-90 leading-relaxed mb-6 md:mb-8">
        Congratulations on joining BotMaa! You're now part of an exclusive community that trusts
        data-driven precision over market noise. <br /><br />
        Our algorithms are built to identify opportunities, execute trades efficiently, and manage
        risk with next-level precision — while you focus on what truly matters.
      </p>

      <!-- Image Container to Reserve Space -->
      <div class="relative h-48 md:h-56 lg:h-64 w-full pointer-events-none">
        <!-- Positioned Image -->
        <img
          src="./assets/Image_2_person_viewing.png"
          alt="Businessman"
          class="absolute right-[-15%] md:right-[-18%] lg:right-[-21%] bottom-[-12%] md:bottom-[-15%] lg:bottom-[-17%] w-48 h-60 md:w-56 md:h-72 lg:w-64 lg:h-80 object-contain drop-shadow-2xl"
        />
      </div>

      <!-- Floating Circles -->
      <!-- Floating Circles with Lucide Icons -->

      <div
        class="absolute top-[40%] right-[-5%] md:right-[-6%] lg:right-[-7%] h-10 w-10 md:h-12 md:w-12 lg:h-14 lg:w-14 rounded-full bg-mauve flex items-center justify-center shadow-xl animate-float-slow"
      >
        <img
          src="assets/Vector__1_-removebg-preview.png"
          alt="Up and Down Arrows"
          class="w-6 h-6 md:w-7 md:h-7 lg:w-8 lg:h-8"
        />
      </div>

      <div
        class="absolute top-1/2 -translate-y-1/2 left-20 md:left-24 lg:left-32 h-10 w-10 md:h-12 md:w-12 lg:h-14 lg:w-14 rounded-full bg-mauve backdrop-blur-lg flex items-center justify-center shadow-2xl animate-float-medium"
      >
        <img src="assets/rupee.png" alt="" class="w-5 h-6 md:w-6 md:h-7 lg:w-6 lg:h-8" />
      </div>

      <div
        class="absolute bottom-[-3%] md:bottom-[-4%] lg:bottom-[-5%] left-20 md:left-24 lg:left-32 h-10 w-10 md:h-12 md:w-12 lg:h-14 lg:w-14 rounded-full bg-mauve backdrop-blur-lg flex items-center justify-center shadow-3xl animate-float-fast"
      >
        <img src="assets/Group 427319132.png" alt="" class="w-5 h-6 md:w-6 md:h-7 lg:w-6 lg:h-8" />
      </div>
    </div>
  </div>
</div>
